import { Vector3 as o } from "three";
const n = new o(), s = (r, t = new o()) => t.fromArray(r.points[1]).sub(n.fromArray(r.points[0]));
export {
  s as MuscleToVector
};
//# sourceMappingURL=index.js.map
